// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var React = require("react");
var Caml_obj = require("rescript/lib/js/caml_obj.js");
var MomentTimezone = require("moment-timezone");
var JsxRuntime = require("react/jsx-runtime");
var Utils$ReactHooksTemplate = require("./common/utils.res.js");
var DomainModel$ReactHooksTemplate = require("./settings/domainModel.res.js");

function empty(param) {
  return {
          email: Curry._1(DomainModel$ReactHooksTemplate.$$String.Email.empty, undefined),
          organization: "",
          invalidEmail: false
        };
}

function setEmail(email, t) {
  return {
          email: email,
          organization: t.organization,
          invalidEmail: t.invalidEmail
        };
}

function setOrgnaization(organization, t) {
  return {
          email: t.email,
          organization: organization,
          invalidEmail: t.invalidEmail
        };
}

function email(t) {
  return t.email;
}

function organization(t) {
  return t.organization;
}

var SignUpParams = {
  empty: empty,
  setEmail: setEmail,
  setOrgnaization: setOrgnaization,
  email: email,
  organization: organization
};

function SignUp(props) {
  var match = React.useState(function (param) {
        return empty();
      });
  var setState = match[1];
  var state = match[0];
  var handleFormInputChange = function ($$event) {
    var name = $$event.target.name;
    var value = $$event.target.value;
    switch (name) {
      case "email" :
          Curry._1(setState, (function (state) {
                  return {
                          email: value,
                          organization: state.organization,
                          invalidEmail: state.invalidEmail
                        };
                }));
          if (state.invalidEmail) {
            return Curry._1(setState, (function (state) {
                          return {
                                  email: state.email,
                                  organization: state.organization,
                                  invalidEmail: false
                                };
                        }));
          } else {
            return ;
          }
      case "organization" :
          return Curry._1(setState, (function (state) {
                        return {
                                email: state.email,
                                organization: value,
                                invalidEmail: state.invalidEmail
                              };
                      }));
      default:
        return ;
    }
  };
  var validateForm = function (param) {
    if (Caml_obj.equal(state.email, Curry._1(DomainModel$ReactHooksTemplate.$$String.Email.empty, undefined))) {
      return true;
    } else {
      return state.organization === "";
    }
  };
  return JsxRuntime.jsx("div", {
              children: JsxRuntime.jsx("div", {
                    children: JsxRuntime.jsx("div", {
                          children: JsxRuntime.jsxs("form", {
                                children: [
                                  JsxRuntime.jsx("input", {
                                        name: "authenticity_token",
                                        type: "hidden",
                                        value: Utils$ReactHooksTemplate.csrfToken
                                      }),
                                  JsxRuntime.jsx("input", {
                                        id: "time_zone",
                                        name: "time_zone",
                                        type: "hidden",
                                        value: MomentTimezone.tz.guess(true)
                                      }),
                                  JsxRuntime.jsxs("div", {
                                        children: [
                                          JsxRuntime.jsx("div", {
                                                children: JsxRuntime.jsx("p", {
                                                      children: "Get started with your work email right away",
                                                      className: "text-darkcharcoal text-2xl font-medium px-4"
                                                    }),
                                                className: "text-center flex flex-col gap-2 w-1/2"
                                              }),
                                          JsxRuntime.jsxs("div", {
                                                children: [
                                                  JsxRuntime.jsxs("div", {
                                                        children: [
                                                          JsxRuntime.jsx("label", {
                                                                children: "Email",
                                                                className: "float-left text-darkcharcoal text-sm font-medium mb-1",
                                                                name: "email"
                                                              }),
                                                          JsxRuntime.jsx("input", {
                                                                className: "rounded-lg bg-white w-full h-40-px text-sm font-normal pl-4 pr-3 py-3 focus:border focus:border-black",
                                                                id: "user_email",
                                                                autoComplete: "off",
                                                                name: "email",
                                                                type: "email",
                                                                value: Curry._1(DomainModel$ReactHooksTemplate.$$String.Email.show, state.email),
                                                                onChange: handleFormInputChange
                                                              }),
                                                          state.invalidEmail ? JsxRuntime.jsx("p", {
                                                                  children: "Please enter a valid email address",
                                                                  className: "font-normal text-red-500 text-sm float-left pt-1 font-inter"
                                                                }) : JsxRuntime.jsx(JsxRuntime.Fragment, {})
                                                        ],
                                                        className: ""
                                                      }),
                                                  JsxRuntime.jsxs("div", {
                                                        children: [
                                                          JsxRuntime.jsx("label", {
                                                                children: "Organization Name",
                                                                className: "float-left text-darkcharcoal text-sm font-medium mb-1",
                                                                name: "organization"
                                                              }),
                                                          JsxRuntime.jsx("input", {
                                                                className: "rounded-lg bg-white w-full h-40-px text-sm font-normal pl-4 pr-3 py-3 focus:border focus:border-black",
                                                                id: "user_organization",
                                                                name: "organization",
                                                                type: "organization",
                                                                value: state.organization,
                                                                onChange: handleFormInputChange
                                                              })
                                                        ],
                                                        className: ""
                                                      })
                                                ],
                                                className: "text-center flex flex-col gap-8 w-1/2 max-w-390-px"
                                              }),
                                          JsxRuntime.jsx("div", {
                                                children: JsxRuntime.jsx("div", {
                                                      children: Curry._1(DomainModel$ReactHooksTemplate.$$String.Email.isValid, state.email) ? JsxRuntime.jsx("input", {
                                                              className: "py-10-px px-30-px rounded-lg w-full " + (
                                                                validateForm() ? "disabled-input bg-lightgray text-white" : "bg-black text-ufogreen cursor-pointer"
                                                              ),
                                                              disabled: validateForm(),
                                                              name: "commit",
                                                              type: "button",
                                                              value: "Sign Up",
                                                              onClick: (function (param) {
                                                                  Curry._1(setState, (function (state) {
                                                                          return {
                                                                                  email: state.email,
                                                                                  organization: state.organization,
                                                                                  invalidEmail: true
                                                                                };
                                                                        }));
                                                                })
                                                            }) : JsxRuntime.jsx("input", {
                                                              className: "py-10-px px-30-px rounded-lg w-full " + (
                                                                validateForm() ? "disabled-input bg-lightgray text-white" : "bg-black text-ufogreen cursor-pointer"
                                                              ),
                                                              disabled: validateForm(),
                                                              name: "commit",
                                                              type: "submit",
                                                              value: "Sign Up"
                                                            }),
                                                      className: "w-full"
                                                    }),
                                                className: "flex items-center w-1/2  max-w-390-px"
                                              }),
                                          JsxRuntime.jsxs("div", {
                                                children: [
                                                  JsxRuntime.jsx("div", {
                                                        children: "Already have an account?",
                                                        className: "text-dimgray font-normal text-sm mr-1"
                                                      }),
                                                  JsxRuntime.jsx("a", {
                                                        children: "Sign in",
                                                        className: "text-black font-normal text-sm",
                                                        href: "/users/sign_in"
                                                      })
                                                ],
                                                className: "flex items-center"
                                              })
                                        ],
                                        className: "flex items-center justify-center flex-col gap-8"
                                      })
                                ],
                                className: "w-full justify-center",
                                action: "/api/v1/users/signup",
                                autoComplete: "off",
                                charSet: "UTF-8",
                                method: "post"
                              }),
                          className: "flex items-center justify-center w-full h-4/5"
                        }),
                    className: "max-h-full bg-ghostwhiteblue"
                  }),
              className: "h-full w-full"
            });
}

var make = SignUp;

exports.SignUpParams = SignUpParams;
exports.make = make;
/* react Not a pure module */
